import cx from 'classnames';
import { useIntl, defineMessages } from 'react-intl';
import { Masonry } from 'masonic';

import config from '@plone/registry';
import TeaserDefaultTemplate from '@plone/volto/components/manage/Blocks/Teaser/DefaultBody';

import styles from './styles.module.css';
import type { TestimonialOrNews } from '../../View/NewsTestimonialsView/NewsTestimonialView';
import type { DITSLink } from '@redturtle/qubicaamf-theme/components/Blocks/Listing/DiveInTheSector/Slides';
import MasonryCard from './MasonryCard';
import LoadMorePagination from './LoadMorePagination';
import { Loader } from 'semantic-ui-react';
import MasonryTemplate from './MasonryTemplate';

export type MasonryItemProps = TestimonialOrNews & DITSLink;

interface MasonryProps {
  data: MasonryItemProps[];
  loadMore: () => void;
  totalItems: number;
  loading: boolean;
  classNames?: string;
}

const MasonryWithEmphasizedContent = ({
  data,
  loadMore,
  totalItems,
  loading,
  classNames,
}: MasonryProps) => {
  const intl = useIntl();
  const Container = config.getComponent('Container').component || 'div';

  const teaserData = {
    href: [data[0]],
    use_alternative_preview_image: data[0]?.image_scales
      ?.alternative_preview_image
      ? true
      : false,
    title: data[0]?.dits_short_title ?? data[0]?.title,
    description: data[0].description,
    hide_description: false,
    linkTitle: intl.formatMessage(messages.read_more),
    ctaButtonStyle: 'simple',
  };

  const masonryItems = data.slice(1);

  return (
    <div className={cx(classNames)}>
      <Container className={styles.masonryTemplate}>
        <TeaserDefaultTemplate
          data={teaserData}
          className={cx(
            'has--bg--white has--show_as_card--true',
            styles.firstCard,
          )}
        />

        <MasonryTemplate
          items={masonryItems}
          loading={loading}
          totalItems={totalItems}
          loadMore={loadMore}
        />
      </Container>
    </div>
  );
};
export default MasonryWithEmphasizedContent;
const messages = defineMessages({
  read_more: {
    id: 'read_more',
    defaultMessage: 'Read more',
  },
});
